import { useOnboarding } from '../../context/OnboardingContext'

export default function OnboardingPill() {
  const { state, progress, total, visible, patch } = useOnboarding()
  if (!visible || !state.rail_collapsed) return null
  return (
    <button
      onClick={() => patch({ rail_collapsed: false })}
      style={{
        position: 'fixed', top: 12, right: 12, zIndex: 60,
        background: '#1a1d29', color: '#e5e7eb',
        border: '1px solid #2a2d3a', padding: '6px 12px',
        borderRadius: 20, fontSize: 12, cursor: 'pointer',
      }}
    >
      ✓ {progress}/{total} setup
    </button>
  )
}
